import FetchService from "@core-ui/ApiServices/FetchService";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import EditMarkdownTrigger from "@ext/article/actions/EditMarkdownTrigger";
import DeleteItem from "@ext/item/actions/DeleteItem";
import t from "@ext/localization/locale/translate";
import TemplateService from "@ext/templates/components/TemplateService";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@ui-kit/Dropdown";
import { PanelListItemActionsTrigger } from "@ui-kit/FloatingPanel";
import type { TemplateItemProps } from "./types/constants";

type TemplateActionsProps = {
	template: TemplateItemProps;
	onRefresh: () => Promise<TemplateItemProps[]>;
};

export const TemplateActions = ({ template, onRefresh }: TemplateActionsProps) => {
	const apiUrlCreator = ApiUrlCreatorService.value;
	const { selectedID } = TemplateService.value;

	const loadContent = async () => {
		const response = await FetchService.fetch(apiUrlCreator.getFileContentInGramaxDir(template.id, "template"));
		if (response.ok) return await response.json();
	};

	const saveContent = async (content: string) => {
		await FetchService.fetch(
			apiUrlCreator.updateFileInGramaxDir(template.id, "template"),
			JSON.stringify({ content }),
		);
		const templates = await onRefresh();
		if (selectedID !== template.id) return;

		const refreshedTemplate = templates.find((item) => item.id === template.id);
		if (refreshedTemplate) TemplateService.openItem(refreshedTemplate);
	};

	const deleteTemplate = async () => {
		await FetchService.fetch(apiUrlCreator.removeFileInGramaxDir(template.id, "template"));
		if (selectedID === template.id) TemplateService.closeItem();
		await onRefresh();
	};

	return (
		<DropdownMenu modal={false}>
			<DropdownMenuTrigger asChild>
				<PanelListItemActionsTrigger aria-label={t("templates-panel-actions")} />
			</DropdownMenuTrigger>
			<DropdownMenuContent align="start">
				<EditMarkdownTrigger
					isCurrentItem
					isTemplate={false}
					loadContent={loadContent}
					saveContent={saveContent}
				/>
				<DeleteItem
					confirm={{ title: t("confirm-templates-delete"), confirmText: t("delete"), icon: "trash-2" }}
					onConfirm={deleteTemplate}
				/>
			</DropdownMenuContent>
		</DropdownMenu>
	);
};
